export default "__VITE_ASSET__78a483e9__"